var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('editor',{attrs:{"api-key":"ksfjgviqcct18eda69e21t7gfwzws2t4edsban1h0vbchi3m","init":{
                plugins: 'lists link image table code',
                toolbar: ['undo redo | formatselect fontsizes forecolor backcolor | bold italic underline code | numlist bullist outdent indent | alignleft aligncenter alignright | link image'],
                height: '500px',
                file_picker_types: 'image',
                images_upload_handler: _vm.uploadToS3,
                paste_data_images: true
            }},on:{"onPaste":_vm.pasteHandler},model:{value:(_vm.formNote),callback:function ($$v) {_vm.formNote=$$v},expression:"formNote"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }